import { clsx } from 'clsx';
import { type FC, type PropsWithChildren } from 'react';

import styles from './CardsLayout.css';

export const CardWrapper: FC<PropsWithChildren<{ responsive: boolean; narrow: boolean }>> = ({
  children,
  responsive,
  narrow,
}) => (
  <div
    className={clsx(
      styles['card-wrapper'],
      responsive && styles['card-wrapper_responsive'],
      narrow && styles['card-wrapper_narrow'],
    )}
  >
    {children}
  </div>
);
export const AdfoxParallaxBannerWrapper: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles['adfox-parallax-banner-wrapper']}>{children}</div>
);
export const AdfoxTgbBannerWrapper: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles['adfox-tgb-banner-wrapper']}>{children}</div>
);
